import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Linkedin, Twitter, Instagram, Youtube, Github } from "lucide-react";
import { profile } from "../mock/mock";

export default function Footer() {
  return (
    <footer className="section-ink grain">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-7">
            <div className="tag-mono mb-6">[ Let’s build ]</div>
            <h2 className="headline-lg text-[var(--cream)] max-w-3xl">
              If you are building for the future,{" "}
              <span className="italic-serif text-[var(--molten)]">let’s make it real.</span>
            </h2>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/contact" className="btn-cream">
                Book a conversation <ArrowUpRight size={16} />
              </Link>
              <a href={profile.socials.topmate} target="_blank" rel="noreferrer" className="btn-outline text-[var(--cream)] border-[var(--cream)]/50 hover:bg-[var(--cream)] hover:text-[var(--ink)]">
                1:1 on Topmate <ArrowUpRight size={16} />
              </a>
            </div>
          </div>

          <div className="md:col-span-5">
            <div className="grid grid-cols-2 gap-8">
              <div>
                <div className="tag-mono mb-4">Navigate</div>
                <ul className="space-y-2 text-[var(--cream)]/80">
                  <li><Link to="/about" className="link-underline">About</Link></li>
                  <li><Link to="/awards" className="link-underline">Awards</Link></li>
                  <li><Link to="/speaking" className="link-underline">Speaking</Link></li>
                  <li><Link to="/luminarc" className="link-underline">Luminarc</Link></li>
                  <li><Link to="/insights" className="link-underline">Insights</Link></li>
                </ul>
              </div>
              <div>
                <div className="tag-mono mb-4">Elsewhere</div>
                <ul className="space-y-2 text-[var(--cream)]/80">
                  <li><a href={profile.socials.linkedin} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 link-underline"><Linkedin size={14}/> LinkedIn</a></li>
                  <li><a href={profile.socials.twitter} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 link-underline"><Twitter size={14}/> X / Twitter</a></li>
                  <li><a href={profile.socials.instagram} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 link-underline"><Instagram size={14}/> Instagram</a></li>
                  <li><a href={profile.socials.youtube} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 link-underline"><Youtube size={14}/> YouTube</a></li>
                  <li><a href={profile.socials.github} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 link-underline"><Github size={14}/> GitHub</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[var(--cream)]/15 flex flex-col md:flex-row justify-between gap-4 text-[var(--cream)]/60 text-sm">
          <div className="font-mono uppercase tracking-[0.14em] text-xs">
            © {new Date().getFullYear()} Dr. Drijesh Ppatel · All rights reserved
          </div>
          <div className="font-mono uppercase tracking-[0.14em] text-xs">
            Engineering Leader · GenAI · Cybersecurity
          </div>
        </div>
      </div>
    </footer>
  );
}
